import React, { useEffect, useState } from "react";
import { Select } from "antd";
import '../../../../../styles/component/leave-period-dropdown.scss';
import server from "../../../../../server";
import Locale from "../../../../../core/locale/locale";
import dayjs from "dayjs";

interface LeavePeriod {
    active: boolean,
    auditInfo: {
        createdOn: Date | string,
        createdBy: string,
        updatedOn: Date | string,
        updatedBy: string
    }
    id: string;
    displayName: string;
    startDate: string;
    endDate: string;
}

interface SelectOption {
    label: React.ReactNode;
    value: string;
}

interface ILeavePeriodProps {
    setLeavePeriod: (val: string) => void;
}

const LeavePeriodDropdown: React.FC<ILeavePeriodProps> = ({setLeavePeriod}) => {
    const [leavePeriods, setLeavePeriods] = useState<LeavePeriod[]>([]);
    const [selectedPeriodId, setSelectedPeriodId] = useState<string>();

    useEffect(() => {
        fetchLeavePeriods();
    }, []);

    const fetchLeavePeriods = async () => {
        const response: LeavePeriod[] = await server.leave.period.list();
        const sorted = response
            .filter(p => p.active)
            .sort((a, b) => {
                const startDiff =
                    new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
                return startDiff !== 0
                    ? startDiff
                    : new Date(b.endDate).getTime() - new Date(a.endDate).getTime();
            });
        setLeavePeriods(sorted);

        if (sorted.length) {
            setSelectedPeriodId(sorted[0].id);
            setLeavePeriod(sorted[0].id);
        }
    };

    const handleOnChange = (value: string) => {
        setSelectedPeriodId(value);
        setLeavePeriod(value);
    };

    const selectedPeriod = leavePeriods.find(
        period => period.id === selectedPeriodId
    );

    const options: SelectOption[] = leavePeriods.map(item => {
        const startDate = item.startDate
            ? dayjs(item.startDate).format(Locale.displayDate)
            : "-";

        const endDate = item.endDate
            ? dayjs(item.endDate).format(Locale.displayDate)
            : "-";

        return {
            value: item.id,
            label: (
                <span className="select-item-text">
                {item.displayName}
                    <span className="sub-text">
                    {" "}({startDate} to {endDate})
                </span>
            </span>
            )
        };
    });

    return (
        <div className="leave-period-wrapper">
            <div className="leave-period__heading">
                <h5 className={'title'}>
                    📅 Leave Period
                </h5>
                <div className={'dropdown'}>
                    <Select
                        value={selectedPeriodId}
                        options={options}
                        onChange={handleOnChange}
                        placeholder="Select leave period"
                    />
                </div>
            </div>

            <div className="leave-period__footer-text">
                {selectedPeriod ? (
                    <span>
                        Showing results for leave period{" "}
                        <span className={'period-name'}>{selectedPeriod.displayName}</span>
                        {/*<span className={'period-range'}>*/}
                        {/*    ({selectedPeriod.startDate} to {selectedPeriod.endDate})*/}
                        {/*</span>*/}
                    </span>
                ) : (
                    <span>
                           No records found for the selected leave period.
                        </span>
                )}
            </div>

        </div>
    );
};

export default LeavePeriodDropdown;
